















import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Spinner extends Vue {
  @Prop() private nameText!: string;
  @Prop() private durationText!: string;
  @Prop() private priceText!: string;
  @Prop({ default: false }) private selected!: boolean;
}
